/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-consumable-stock.reducer';

export const PharmacyConsumableStockDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyConsumableStockEntity = useAppSelector(state => state.pharmacyConsumableStock.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyConsumableStockDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.detail.title">PharmacyConsumableStock</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.id}</dd>
          <dt>
            <span id="brandId">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.brandId">Brand Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.brandId}</dd>
          <dt>
            <span id="stockQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.stockQty">Stock Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.stockQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.expDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.cursor}</dd>
          <dt>
            <span id="batchNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.batchNumber">Batch Number</Translate>
            </span>
            <UncontrolledTooltip target="batchNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.batchNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyConsumableStockEntity.batchNumber}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.taxCode}</dd>
          <dt>
            <span id="mrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.mrp">Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.mrp}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.price">Price</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.price}</dd>
          <dt>
            <span id="remainingQuantity">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.remainingQuantity">Remaining Quantity</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.remainingQuantity}</dd>
          <dt>
            <span id="packs">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.packs">Packs</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.packs}</dd>
          <dt>
            <span id="HSNCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.HSNCode">HSN Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.HSNCode}</dd>
          <dt>
            <span id="rack">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.rack">Rack</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.rack}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.discount}</dd>
          <dt>
            <span id="available">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.available">Available</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.available ? 'true' : 'false'}</dd>
          <dt>
            <span id="internal">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.internal">Internal</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.internal ? 'true' : 'false'}</dd>
          <dt>
            <span id="shipmentItemId">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.shipmentItemId">Shipment Item Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.shipmentItemId}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.modifiedByType}</dd>
          <dt>
            <span id="margin">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.margin">Margin</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumableStockEntity.margin}</dd>
          <dt>
            <span id="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.cessAmount">Cess Amount</Translate>
            </span>
            <UncontrolledTooltip target="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.cessAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyConsumableStockEntity.cessAmount}</dd>
          <dt>
            <span id="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.exempted">Exempted</Translate>
            </span>
            <UncontrolledTooltip target="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.exempted" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyConsumableStockEntity.exempted ? 'true' : 'false'}</dd>
          <dt>
            <span id="importDuty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.importDuty">Import Duty</Translate>
            </span>
            <UncontrolledTooltip target="importDuty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.importDuty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyConsumableStockEntity.importDuty}</dd>
          <dt>
            <span id="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.freeQty">Free Qty</Translate>
            </span>
            <UncontrolledTooltip target="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.help.freeQty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyConsumableStockEntity.freeQty}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyConsumableStockEntity.pharmacy ? pharmacyConsumableStockEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.consumable">Consumable</Translate>
          </dt>
          <dd>{pharmacyConsumableStockEntity.consumable ? pharmacyConsumableStockEntity.consumable.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.supplier">Supplier</Translate>
          </dt>
          <dd>{pharmacyConsumableStockEntity.supplier ? pharmacyConsumableStockEntity.supplier.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.bill">Bill</Translate>
          </dt>
          <dd>{pharmacyConsumableStockEntity.bill ? pharmacyConsumableStockEntity.bill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumableStock.uqcType">Uqc Type</Translate>
          </dt>
          <dd>{pharmacyConsumableStockEntity.uqcType ? pharmacyConsumableStockEntity.uqcType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-consumable-stock" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-consumable-stock/${pharmacyConsumableStockEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyConsumableStockDetail;
